export default ({
  MuiDialog: {
    container: {
      alignItems: "start",
    }
  },
  MuiDialogContentText: {
    root: {
      color: "black"
    }
  }
})
